import { ContainerImpl } from './Container/impl';
import { WorkspaceServiceImpl } from './impl';
import { selfOwnedWidgetRegistry } from './selfOwnedWidgetRegistry';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { IsomorphicBindings } from 'src/types/bindings';

export const localWorkspaceServiceModule = new TypedContainerModule<IsomorphicBindings>((bind) => {
    bind('WorkspaceService').to(WorkspaceServiceImpl).inSingletonScope();
    // Each layout container needs its own lifecycle, so the binding is transient
    // (inversify's default for class bindings). The factory wraps `.get()` so
    // WorkspaceServiceImpl can request fresh containers via injection.
    bind('WorkspaceContainer').to(ContainerImpl);
    bind('WorkspaceContainerFactory')
        .toDynamicValue((context) => {
            return () => context.container.get('WorkspaceContainer');
        })
        .inSingletonScope();
    bind('IoCContainer')
        .toDynamicValue((context) => context.container)
        .inSingletonScope();
    bind('SelfOwnedWidgetRegistry').toConstantValue(selfOwnedWidgetRegistry);
    bind('ContainerTabResolver').toDynamicValue((context) => context.container.get('WorkspaceService'));
});
